var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTextDonationNt6000(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 20,
    viewBox: "0 0 119 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.42 1.76H15.24V18.3H10.12L6.68 12.62H6.26V18.28H0.34V1.76H5.64L8.98 7.4H9.42V1.76ZM30.102 1.68V7.46H26.682V18.3H20.062V7.46H16.642V1.68H30.102ZM43.6123 7.4L45.6323 9.04V15.42L43.2123 17.68H41.7523V19.3H35.6923V17.68H31.9323V12.98H39.0723V11.96H33.9723L31.9523 10.3V4.24L34.3723 1.98H35.6923V0.5H41.7523V1.98H45.1923V6.38H38.0923V7.4H43.6123ZM60.5838 7.76L62.1238 9.18V16.4L60.0438 18.48H49.8838L47.8038 16.4V3.9L50.4038 1.32H61.6638V6.38H53.7438V7.76H60.5838ZM56.4838 13.66V12.02H53.7438V13.66H56.4838ZM64.1342 13.12H69.2942V15.9L66.9742 19.86H64.1342V13.12ZM71.2813 16.22V3.68L73.6013 1.3H83.2413L85.5813 3.68V16.22L83.2413 18.46H73.6013L71.2813 16.22ZM77.2613 6.9V12.98H79.6013V6.9H77.2613ZM87.5898 16.22V3.68L89.9098 1.3H99.5498L101.89 3.68V16.22L99.5498 18.46H89.9098L87.5898 16.22ZM93.5698 6.9V12.98H95.9098V6.9H93.5698ZM103.898 16.22V3.68L106.218 1.3H115.858L118.198 3.68V16.22L115.858 18.46H106.218L103.898 16.22ZM109.878 6.9V12.98H112.218V6.9H109.878Z",
    fill: "#4527A0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextDonationNt6000);
export default __webpack_public_path__ + "static/media/text-donation-NT6000.db989750cc22cb24f979aa118f8b2f41.svg";
export { ForwardRef as ReactComponent };